import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useIAChatHistoryStyles = makeStyles(() => ({
  historyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  historyItem: {
    padding: spacing.sm,
    backgroundColor: colors.surface,
    border: `1px solid ${colors.chatBorder}`,
    borderRadius: radius.sm,
    cursor: 'pointer',
    transition: 'background-color 0.2s ease, border-color 0.2s ease',
    '&:hover': {
      backgroundColor: colors.hoverSurface,
      borderColor: colors.primary,
    },
  },
  historyItemTitle: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.text,
    marginBottom: 4,
  },
  historyItemDate: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: colors.label,
  },
  emptyText: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.label,
    textAlign: 'center',
  },
}));
